import React, { useEffect, useMemo, useState } from 'react';
import { Card, Select, Typography } from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import QaqcPipeHeatnoCreate from './QaqcPipeHeatnoCreate';
import type { QaqcPipeHeatno } from '../../../../types';
import { fetchSqlData } from '../../../../services/api';
import { useGetQaqcPipeHeatno } from '../../../../hooks/genericHooks';

const QaqcPipeHeatnoEdit: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation() as { state?: { record?: QaqcPipeHeatno } };
  const params = useParams();
  const [record, setRecord] = useState<QaqcPipeHeatno | undefined>(state?.record);
  const { data: rowsResp } = useGetQaqcPipeHeatno();

  useEffect(() => {
    const load = async () => {
      if (record) return;
      const id = params.id ? Number(params.id) : NaN;
      if (!Number.isFinite(id)) return;
      try {
        const res = await fetchSqlData('qaqc_pipe_heatno', 'id', id);
        const row = Array.isArray((res as any)?.data) ? (res as any).data[0] : (Array.isArray(res) ? (res as any)[0] : undefined);
        if (row) setRecord(row as QaqcPipeHeatno);
      } catch {}
    };
    load();
  }, [params.id]);

  const goBack = () => navigate('/qaqc/piping/operations/heatnos');

  const options = useMemo(() => {
    const rows: QaqcPipeHeatno[] = (rowsResp?.data as any) || [];
    return rows.map(s => ({ value: s.id, label: `${s.component_name || ''} — ${s.heat_no || ''}`, rec: s }))
      .sort((a,b)=>String(a.label).localeCompare(String(b.label)));
  }, [rowsResp]);

  const missingId = !record && !(params.id && Number.isFinite(Number(params.id)));

  return (
    <>
      {missingId && (
        <Card size="small" title={<Typography.Text strong>Select a heat number to edit</Typography.Text>}>
          <Select
            showSearch
            allowClear
            placeholder="Search heat numbers"
            style={{ width: 420 }}
            options={options}
            optionFilterProp="label"
            filterOption={(input, option) => {
              const label = String(option?.label || '').toLowerCase();
              const tokens = input.trim().toLowerCase().split(/\s+/).filter(Boolean);
              return tokens.every(t => label.includes(t));
            }}
            onChange={(val, opt: any) => {
              const id = Number(val);
              const rec = opt?.rec as QaqcPipeHeatno | undefined;
              if (Number.isFinite(id)) {
                if (rec) setRecord(rec);
                navigate(`/qaqc/piping/operations/heatnos/edit/${id}`, { state: { record: rec } });
              }
            }}
          />
        </Card>
      )}
      <QaqcPipeHeatnoCreate
        mode="edit"
        initialValues={record}
        onSaved={goBack}
        onCancel={goBack}
        onBack={goBack}
      />
    </>
  );
};

export default QaqcPipeHeatnoEdit;
